import { configService } from '@/helpers';

export function submitContactForm(data: { name: string, email: string; message: string}): Promise<Response> {
  return fetch(configService.contactMessages, {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body: JSON.stringify(data)
  })
}
